var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ps-card-peek ps-absolute ps-bottom-0 ps-w-full",class:[
    {
      'ps-is-active': _vm.isActive
    }
  ],on:{"transitionend":_vm.handleTransitionEnd}},[_c('div',{staticClass:"ps-decorator ps-rounded ps-px-4 ps-bg-brand-gray-100 ps-text-white ps-h-16 ps-flex ps-items-center"},[(_vm.isReady)?_c('h3',{staticClass:"ps-text-xl ps-text-brand-brown-800 ps-font-bold"},[_vm._v("\n      "+_vm._s(_vm.card.name)+"\n    ")]):_vm._e()]),_c('div',{staticClass:"ps-h-32 ps-w-full bg-brand-brown-100"})])}
var staticRenderFns = []

export { render, staticRenderFns }